export default __webpack_public_path__ + "static/media/pexels-rodnae-productions-7841832.7d7e795e.jpg";